export const TABLE_HEAD = [
    { id: 'Risk ID', label: 'Risk ID' },
    { id: 'Description', label: 'Description' },
    { id: 'Category', label: 'Category' },
    { id: 'Date Identified', label: 'Date Identified' },
    { id: 'Last Reviewed', label: 'Last Reviewed' },
    { id: 'Status', label: 'Status' },
];